<template>
    <div class="page">
        <div class="box" style="overflow:auto">
            <div class="banner">
                <div class="iaas_left">
                    <div class="title">新闻动态&emsp;<span class="text">国产自主可控区块链技术领军者</span></div>
                </div>
              <div class="btnBox" style="text-align: left;">
                <el-button class="btn" @click="goabout()">联系我们</el-button>
              </div>
            </div>
            <div class="box-big">
                <div class="newsBox">
                    <div class="content">
                        <ul class="newsList">
                            <li class="newsItem" v-for="(item, index) in newsList" :key="index" @click="newsJump(item)">
                                <div class="itemBox">
                                    <div class="item_bottom">
                                        <div class="item_title">{{ item.title }}</div>
                                        <div class="item_text">
                                            {{ item.design }}
                                        </div>
                                        <div style="font-size: 12px;color: #b7bfcf;line-height: 22px">{{ item.publishDate }}
                                        </div>
                                    </div>
                                </div>
                                <div class="itemImg ">
                                    <img :src="item.img" alt="">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--      <Footer></Footer>-->
    </div>
</template>

<script>
import Footer from "../../components/mian-footer.vue"
import img1 from "../../assets/news/news1-1.png"
import img2 from "../../assets/news/news2-1.png"
import img3 from "../../assets/news/news3-1.png"
import img4 from "../../assets/news/news4.png"
import img5 from "../../assets/news/news5-1.png"
import img6 from "../../assets/news/news6-1.png"
import img7 from "../../assets/news/news7-1.png"
import img8 from "../../assets/news/news8-1.png"
import img9 from "../../assets/news/news9-0.png"
import img10 from "../../assets/news/news10-0.png"
import img11 from "../../assets/news/news11-0.png"
import img12 from "../../assets/news/news12-0.png"
import img13 from "../../assets/news/news13-0.png"
import img14 from "../../assets/news/news14-0.png"
import img15 from "../../assets/news/news15-0.png"
import img16 from "../../assets/news/news16-0.png"
import img17 from "../../assets/news/news17-0.png"
import img18 from "../../assets/news/news18-0.png"
import img19 from "../../assets/news/news19-0.png"
import img20 from "../../assets/news/news20-0.png"
import img21 from "../../assets/news/news21-0.png"
import img22 from "../../assets/news/news22-0.jpg"
import img23 from "../../assets/news/news23-0.png"
import img24 from "../../assets/news/news24-bg.jpg"
import img25 from "../../assets/news/news25-0.png"
import img26 from "../../assets/news/news26-1.png"
import img27 from "../../assets/news/news27-0.png"
import img28 from "../../assets/news/news28-0.png"
import img29 from "../../assets/news/news29-2.png"
import img30 from "../../assets/news/news30-1.png"
import img31 from "../../assets/news/news31-1.png"
import img32 from "../../assets/news/news32.png"
import img33 from "../../assets/news/news33-0.png"
import img34 from "../../assets/news/news34-0.png"
import img35 from "../../assets/news/news35-0.png"
import img36 from "../../assets/news/news36-0.png"
import img37 from "../../assets/news/news37-0.png"
import img38 from "../../assets/news/news38-0.png"
import img39 from "../../assets/news/202004-1.png"

import axios from "axios"

export default {
    name: "index.vue",
    components: {
        Footer
    },
    data() {
        return {
            newsList: [],
            oldNewList: [
                {
                    title: "【转载】中纪委：区块链蕴含的变革力量",
                    design: "引言：习近平总书记在中央政治局第十八次集体学习时指出：区块链技术的集成应用在新的技术革新和产业变革中起着重要作用。我们要把区块链作为核心技术自主创新的重要突破口，明确主攻方向，加大投入力度，着力攻克一批关键核心技术，加快推动区块链技术和产业创新发展。",
                    img: img38,
                    publishDate: "2020-04-10 14:41:45",
                    routerName: "news38"
                },

                {
                    title: "兆物信连产品入选“长沙市软件和信息技术服务业应用场景清单”！",
                    design: "为进一步打造软件和信息技术服务业应用场景，立足本地重点突破一批技术先进、性能优秀、应用效果好的软件产业标志性产品、平台和服务，按照全市软件产业发展专题研究会议精神，结合《长沙市软件和信息技术服务业发展三年行动计划（2020－2022年）》总体部署，长沙面向全市征集了一批软件和信息技术服务业应用场景。",
                    img: img37,
                    publishDate: "2020-04-03 17:24:35",
                    routerName: "news37"
                },

                {
                    title: "产品推荐 | 兆物信连区块链在线招投标系统介绍",
                    design: "2020年2月8日，发改委发布《关于积极应对疫情创新做好招投标工作保障经济平稳运行的通知》，强调疫情期间，全面推行在线投标、开标、异地评标等。",
                    img: img36,
                    publishDate: "2020-04-03 12:25:47",
                    routerName: "news36"
                },

                {
                    title: "产品推荐 | 兆物信连国密区块链科技创新券服务平台介绍",
                    design: "区块链技术作为当下最有潜力触发颠覆性革命浪潮的核心技术，具有的去中心化、难以篡改、扩展性大、灵活性强等技术特征非常适应创新券数据保护的核心诉求，为创新券数据保护提供了一套全新解决方案和重要支撑。密码技术作为区块链中的底层技术和核心技术之一，在区块链的实际应用中发挥着至关重要的作用。通过国产商用密码建立自主的、可信的，以密码学为基础的安全机制是区块链应用的关键因素之一。",
                    img: img35,
                    publishDate: "2020-03-24 12:12:42",
                    routerName: "news35"
                },

                {
                    title: "产品推荐  兆票-兆物信连区块链供应链金融平台介绍",
                    design: "兆票-兆物信连区块链供应链金融平台是湖南兆物信连信息科技有限公司专为供应链金融企业提供产融信息对接的区块链创新金融服务平台。平台以供应链为基础，以真实贸易为前提，运用贸易自偿性作为风控方式，基于兆物信连自主研发的MT国产高性能安全可靠区块链基础平台为应收账款融资、存货质押融资、反向保理、贷后一体化等服务提供信任支撑，将供应链金融链条中企业融资的高风险转变为产业链条的低风险。",
                    img: img34,
                    publishDate: "2020-03-20 16:26:15",
                    routerName: "news34"
                },

                {
                    title: "产品推荐 | 兆物信连PKMT MAIN NODE数据上链设备介绍",
                    design: "近日，由湖南兆物信连信息科技有限公司自主研发的一套基于AIO-3399C高性能开源平台的小型嵌入式主机——PKMT MAIN NODE数据上链设备全新问世，它的出现为区块链数据应用上链创建了一个绿色安全可信可靠的通道。",
                    img: img33,
                    publishDate: "2020-03-13 11:45:57",
                    routerName: "news33"
                },


                {
                    title: "兆物信连子公司入选“2020年湖南省大数据和区块链产业发展重点项目”！",
                    design: "为深入贯彻习近平总书记关于统筹推进新冠肺炎疫情防控和经济社会发展重要讲话精神，落实省委、省政府大力发展大数据和区块链产业的决策部署，加快新型基础设施建设，培育壮大新兴产业。",
                    img: img32,
                    publishDate: "2020-03-28 16:51:32",
                    routerName: "news32"
                },

                {
                    title: "“兆物信连”与“湘江云”拟共建区块链联合创新实验室",
                    design: "2020年3月20日，湖南兆物信连信息科技有限公司与湖南湘江云计算中心有限责任公司共建区块链联合创新实验室合作框架协议签约仪式在市国投集团总部举行。",
                    img: img31,
                    publishDate: "2020-03-23 15:12:34",
                    routerName: "news31"
                },

                {
                    title: "兆物信连入选长沙市新型冠状病毒感染的肺炎疫情应急专题科技计划项目！",
                    design: "3月19日，长沙市科学技术局对“长沙市新型冠状病毒感染的肺炎疫情应急专项科技计划项目”进行了公示，兆物信连在疫情期间研发的“新冠肺炎多源疫情区块链监测与智能挖掘分析平台”项目获得一致认可！",
                    img: img30,
                    publishDate: "2020-03-19 12:15:51",
                    routerName: "news30"
                },


                {
                    title: "兆物信连牵手浩云科技，开启“物联网+区块链”业务新篇章",
                    design: "3月12日，兆物信连与浩云科技签署合作协议，成立广州浩云区块链科技有限公司（下称“合资公司”），合资公司成立旨在进一步深化区块链领域技术研发及业务开拓，并合力争取合资公司在2020 年底前至少拿到一个国家互联网信息办公室区块链信息服务备案。这是兆物信连与浩云科技联合在“物联网+区块链”业务布局中的一个重大举措。",
                    img: img29,
                    publishDate: "2020-03-12 15:06:45",
                    routerName: "news29"
                },

                {
                    title: "兆物信连与泰成江润签订江西省区域销售合作协议",
                    design: "2020年3月，湖南兆物信连信息科技有限公司与南昌泰成江润通讯有限公司达成江西省区域销售合作并签订协议。",
                    img: img28,
                    publishDate: "2020-03-11 16:12:02",
                    routerName: "news28"
                },

                {
                    title: "预告：兆物信连登陆湖南长城“PK生态系列公开课”将于3月11日开播！",
                    design: "2020年3月10日，由长沙市信息安全产业链办公室指导，长沙高新区企业湖南长城科技信息有限公司（以下简称湖南长城科技）等发起的“PK生态系列公开课”第二期的“产品方案”系列课程携各生态厂商的主打产品与大家正式见面。全市100多家信创企业在“云”上集结，共同开启PK学习探讨之旅，在应对疫情影响面前，展现信创行业良好的进取风貌。",
                    img: img27,
                    publishDate: "2020-03-10 14:13:15",
                    routerName: "news27"
                },

                {
                    title: "区块链供应链金融平台建设实践及思考",
                    design: "近日，中国金融科技主导期刊、广东省特色科技期刊《金融科技时代》（2020年第2期）刊登了湖南兆物信连信息科技有限公司董事长曹源博士与广东微模式软件股份有限公司董事长陈友斌先生联合发表的署名文章，文章以《区块链供应链金融平台建设实践及思考》为题，汇集了兆物信连五年来深耕区块链底层技术研发和区块链供应链金融产品、解决方案的宝贵经验与实际成果，分析了供应链金融平台的现状及痛点，阐述了区块链供应链金融平台建设的必要性",
                    img: img26,
                    publishDate: "2020-03-02 16:12:54",
                    routerName: "news26"
                },

                {
                    title: "鲲鹏湘约，携手并进——兆物信连加入鲲鹏生态",
                    design: "2020年1月9日，为快速推动华为鲲鹏计算产业与智能网联汽车产业在长沙得到更快、更优、更强的发展，在湖南省人民政府指导下，由湖南省工业和信息化厅、长沙市人民政府主办，湖南湘江新区管理委员会、华为技术有限公司承办的湖南鲲鹏计算与智能网联汽车生态创建启动仪式活动在长沙梅溪湖国际文化艺术中心盛大举行，兆物信连作为湖南鲲鹏计算产业联盟成员受邀参加了此次启动仪式。",
                    img: img25,
                    publishDate: "2020-01-09 16:14:54",
                    routerName: "news25"
                },
                {
                    title: "只争朝夕，不负韶华 | 兆物信连2019年度盘点",
                    design: "时序更替，光阴轮转。奋斗的2019刹那而过！",
                    img: img24,
                    publishDate: "2020-01-03 14:50:01",
                    routerName: "news24"
                },

                {
                    title: "兆物信连与小舟天网络签订战略合作协议",
                    design: "2019年12月24日，湖南兆物信连信息科技有限公司与湖南小舟天网络科技有限公司达成战略合作关系并签订协议。",
                    img: img23,
                    publishDate: "2019-12-24 15:30:25",
                    routerName: "news23"
                },

                {
                    title: "PKMT-软硬件一体国产安全可控区块链基础平台产品白皮书",
                    design: " 区块链是国家战略，国产化替代是近几年国内信息化建设尤其是信息基础设施建设必须完成的步骤，中国要完成区块链的底层技术突破和大规模应用，必须建设发展中国自己的安全可靠的区块链基础平台。",
                    img: img22,
                    publishDate: "2020-01-02 17:20:24",
                    routerName: "news22"
                },

                {
                    title: "兆物信连在北京正式发布基于飞腾处理器的国产高性能安全可靠区块链基础平台PKMT",
                    design: "2019年12月19日,由国内CPU研制领军企业天津飞腾信息技术有限公司举办的“2019飞腾生态伙伴大会”在北京国际会议中心盛大召开。大会吸引了包括两院院士、业内专家、政府主管部门、行业协会、用户单位、软硬件厂商、系统集成商、媒体、金融机构在内的全国各地的参会代表共计2000余人参加，参会单位和企业超过500家。",
                    img: img20,
                    publishDate: "2019-12-20 16:35:20",
                    routerName: "news21"
                },

                {
                    title: "兆物信连联合邦禾数科打造金融机构区块链风控平台",
                    design: "2019年12月18日，湖南兆物信连信息科技有限公司与湖南邦禾数据科技有限公司签订了技术合作协议。双方将共同开发建设湖南省金融机构区块链风控平台，帮助银行方提升湖南地区金融机构的风险防控能力和客户服务能力。",
                    img: img21,
                    publishDate: "2019-12-18 16:11:21",
                    routerName: "news20"
                },

                {
                    title: "兆物信连联合赛医共同发起“赛医健康联盟链”",
                    design: "为了积极响应“健康中国2030规划纲要”和“健康中国行动”,国家中医药管理局亚健康干预技术实验室于2019年正式推出了“亚健康管理师”证书，并联合湖南赛医信息科技有限公司共同打造一个亚健康管理师考培系统，为广大用户提供亚健康管理师自在线培训、考试、认证服务。",
                    img: img19,
                    publishDate: "2019-12-13 15:31:26",
                    routerName: "news19"
                },

                {
                    title: "兆物信连携MT亮相“2019湖南（长沙）网络安全·智能制造大会”",
                    design: "2019年11月28日-30日，由湖南省委网信办、湖南省工业和信息化厅、湖南省科学技术协会、长沙市人民政府、中国电子信息产业集团有限公司权威主办的“2019湖南（长沙）网络安全·智能制造大会”在长沙国际会展中心正式开幕，湖南兆物信连信息科技有限公司（国际领先的区块链底层技术及行业应用解决方案提供商）受邀以Pk生态伙伴的身份亮相本次展会，向与会者展示了面向多行业多场景的国产自主可控高性能区块链基础平台MT、区块链行业应用解决方案、区块链创新产品三大业务板块，受到了现场领导与企业的热切关注。",
                    img: img18,
                    publishDate: "2019-11-30 16:11:56",
                    routerName: "news18"
                },

                {
                    title: "兆物信连荣获2019年度区块链技术产业化推进工作先进单位奖",
                    design: "11月25、26日，由中国高科技产业化研究会主办的以“科技赋能·智汇湾区·产业生态”为主题的第二届中国高科技产业化峰会在广州市黄浦区隆重召开。大会设立区块链技术分论坛，由中高会区块链产业联盟主办。兆物信连受邀参加了本次论坛峰会。",
                    img: img17,
                    publishDate: "2019-11-25 16:38:56",
                    routerName: "news17"
                },

                {
                    title: "兆物信连全资子公司中标大型区块链项目",
                    design: "11月22日消息，湖南兆物信连信息科技有限公司全资子公司湖南宸瀚信息科技有限责任公司中标国家XX中心区块链相关项目。",
                    img: img16,
                    publishDate: "2019-11-22 16:11:56",
                    routerName: "news16"
                },

                {
                    title: "长沙市政府副市长邱继兴一行对兆物信连进行了调研",
                    design: "1月22日上午，长沙市政府副市长邱继兴一行对兆物信连及其自主研发的国产自主可靠区块链基础平台MT在“PK体系”及政务、供应链金融、电子存证、溯源体系应用的调研。兆物信连副董事长郭石峰及相关人员进行了接待。",
                    img: img15,
                    publishDate: "2019-11-22 16:11:56",
                    routerName: "news15"
                },
                {
                    title: "区块链来了！兆物信连接受湖南都市频道报道",
                    design: "近日，区块链话题已倍受热议。早在去年11月，长沙高新区就挂牌成立了区块链产业园。不到一年时间，已进驻80多家相关企业。那么，什么是区块链？区块链在社会生活中会有哪些具体的应用？长沙区块链的发展走到了哪一步？带着诸多问题，湖南都市频道记者采访了相关企业、专家，以及管理部门。湖南兆物信连信息科技有限公司也接受了湖南都市频道记者的采访。",
                    img: img14,
                    publishDate: "2019-11-15 15:28:56",
                    routerName: "news14"
                },
                {
                    title: "省政协刘志峰一行到兆物信连走访考察",
                    design: "11月13日，湖南省政协办公厅新闻信息中心主任、云管理中心副主任刘志峰一行来到兆物信连公司走访考察。对公司的生产经营情况、区块链业务和产品建设情况进行了实地考察，兆物信连董事长曹源博士、兆物信连副董事长郭石峰​先生及相关人员进行了接待。",
                    img: img13,
                    publishDate: "2019-11-13 13:02:56",
                    routerName: "news13"
                },
                {
                    title: "兆物信连向湖南省政协专题汇报区块链在政协工作中的应用",
                    design: "2019年11月11日上午，兆物信连董事长曹源博士携公司同事向湖南省政协专题汇报了关于区块链赋能新时代政协工作的建议，省政协罗双全副秘书长、农业和农村委员会周杏武副主任携省政协内设机构人员共同听取了汇报。",
                    img: img12,
                    publishDate: "2019-11-11 16:30:44",
                    routerName: "news12"
                },
                {
                    title: "QBS追溯与品牌工作委员会莅临兆物信连探讨合作",
                    design: "2019年11月3日，QBS追溯与品牌工作委员会莅临兆物信连走访交流，双方专门就品牌防伪，溯源，信息存证，以及QBS追溯与品牌数据存证中心的建设进行了深入讨论。",
                    img: img11,
                    publishDate: "2019-11-03 16:02:56",
                    routerName: "news11"
                },
                {
                    title: "兆物信连参加长沙市发改委《研究区块链产业发展相关工作专题会议》",
                    design: "2019年10月28日下午，长沙市发展改革委召开会议专题研究区块链产业发展相关工作。兆物信连受邀参加本次会议。",
                    img: img10,
                    publishDate: "2019-10-30 17:02:56",
                    routerName: "news10"
                },
                {
                    title: "自主创新，勇往直前——兆物信连坚持致力于推动区块链技术和产业创新发展",
                    design: "2019年10月24日下午，中共中央政治局就区块链技术发展现状和趋势进行第十八次集体学习。中共中央总书记习近平在主持学习时强调，区块链技术的集成应用在新的技术革新和产业变革中起着重要作用。我们要把区块链作为核心技术自主创新的重要突破口，明确主攻方向，加大投入力度，着力攻克一批关键核心技术，加快推动区块链技术和产业创新发展",
                    img: img9,
                    publishDate: "2019-10-29 15:20:24",
                    routerName: "news9"
                },
                {
                    title: "以瑟科技与兆物信连签订技术开发合同",
                    design: "2019年10月，杭州以瑟科技有限公司与湖南兆物信连信息科技有限公司签订了技术开发合作协议。杭州以瑟科技有限公司是一家以科技助力金融，致力于优化供应链金融和房地产金融服务解决方案的高科技企业。此次合作，兆物信连作为区块链底层技术服务商，将使用MT区块链底层技术为支撑业务数据上链存证的区块链底层平台提供技术支撑，助力以瑟科技开发的“回款宝”——按揭保证金短期贷款平台，为购房者、房地产开发商和金融机构提供购房按揭保证金短期贷款申请、审核、放款和还款的线上处理业务流程中，将每笔贷款申请的结果上传到区块链上，作为永久存证使用，进一步增加数据的可信性和不可篡改性。未来，双方均期待更多的合作，以市场需求为导向，不断探索，共同为金融机构、企业提供全面、灵活、个性化的服务，为实体经济发展赋能。",
                    img: img8,
                    publishDate: "2019-10-18 12:11:24",
                    routerName: "news8"
                },
                {
                    title: "大道通途与兆物信连签订技术开发合同",
                    design: "2019年10月初，湖南大道通途会展有限公司与湖南兆物信连信息科技有限公司签订了技术服务协议。此次合作，兆物信连将为大道通途所承办的湖南省农业对外经济合作中心湖南品牌农产品（澳门）展示展销项目提供技术开发与支撑服务。未来，双方将有望在农产品和区块链技术结合领域进行更多探索，为湘农产品走向世界发挥桥梁作用。",
                    img: img7,
                    publishDate: "2019-10-16 16:24:29",
                    routerName: "news7"
                },
                {
                    title: "MT联盟链节点间竞争记账权的机制",
                    design: "在区块链行业应用中，由多方机构共同参与和管理的场景经常出现，MT联盟链就是由若干机构共同参与和管理的区块链技术解决方案，链上的数据只允许系统授权的机构进行读写和交易操作，只有持有相应的数字证书的节点才能负责记账工作。但是这种限制并不是表示记账节点是一成不变的，在一些有高可用环境下，可能存在8个节点参与竞争4个记账节点的场景（一半节点都不能正常工作）。在这种情况，MT的节点竞争记账权的机制就是一个很好的实现方式。",
                    img: img6,
                    publishDate: "2019-10-15 16:20:24",
                    routerName: "news6"
                },
                {
                    title: "湖南省产融信息对接服务平台——供应链金融平台上线，兆物信连提供区块链技术支持",
                    design: "近日，湖南省工业和信息化厅主办的湖南省产融信息对接服务平台——供应链金融平台上线运营。由湖南邦禾资产管理有限公司与湖南兆物信连信息科技有限公司共同开发的“银信区块链电子凭证”也一同上线。",
                    img: img5,
                    publishDate: "2019-09-10 16:26:18",
                    routerName: "news5"
                },
                {
                    title: "邦禾资产与兆物信连签订技术开发合同",
                    design: "2019年8月26日，湖南邦禾资产管理有限公司与湖南兆物信连信息科技有限公司签订了技术合作协议。此次合作，邦禾资产作为金融服务系统的提供方，负责金融产品的开发及金融场景的落地。兆物信连作为区块链底层技术服务商，负责使用MT区块链底层技术为产品项目提供区块链底层技术支持。未来，双方将对金融服务和区块链技术进行更多整合，共同在智慧金融服务板块为产业链上的企业提供智慧金融服务。",
                    img: img4,
                    publishDate: "2019-08-26 15:34:56",
                    routerName: "news4"
                },
                {
                    title: "用区块链技术为供应链金融赋能——兆物信连受邀参加“2019年度湖湘供应链金融发展论坛”",
                    design: "2019年8月15日，由长沙市人民政府金融工作办公室指导，长沙金融业联合会主办，以“协同创新、科技赋能、产融互兴”为主题的“2019年度湖湘供应链金融发展论坛”在长沙华天大酒店隆重举办。湖南兆物信连信息科技有限公司受邀参加了本次论坛。",
                    img: img3,
                    publishDate: "2019-08-15 15:02:55",
                    routerName: "news3"
                },
                {
                    title: "重磅！兆物信连与东华软件建立战略合作伙伴关系，在区块链技术领域展开合作",
                    design: "2019年8月9日，湖南兆物信连信息科技有限公司与东华软件股份公司正式签订了《区块链底层技术及行业解决方案战略合作协议》，建立战略合作伙伴关系。双方将在区块链技术资源共享，区块链前沿技术探索，区块链软件和信息系统研发等方面进行深入合作，为各行业提供先进的区块链底层技术支撑和全面的区块链解决方案。",
                    img: img1,
                    publishDate: "2019-08-09 11:22:26 ",
                    routerName: "news1"
                },
                {
                    title: "长沙环境保护职业技术学院教师一行前往兆物信连进行项目实践",
                    design: "2019年8月1日/讯。近日，长沙环境保护职业技术学院环境经济与信息系在职教师们来到了湖南兆物信连信息科技有限公司，进行了为期半个月的环境大数据处理图片溯源项目实践活动。",
                    img: img2,
                    publishDate: "2019-08-01 16:11:01",
                    routerName: "news2"
                }
            ],
            count: 0,
            page: 1,

            data: [],
            busy: false,
            img1: img1
        }
    },
    computed: {
        noMore() {
            return this.currentPage >= this.pages;
        },
        disabled() {
            return this.loading || this.noMore
        }
    },

    methods: {
        goabout() {
            this.$router.push({
                name: 'about'
            })
        },
        _getNewsList(page) {
            this.busy = true
            /*https://article.trilliontrust.com/publish-article/app/article/zhaowulist */
            axios.post("https://article.trilliontrust.com/publish-article/app/article/zhaowulist ", {
                // axios.post("https://192.168.200.110:10555/publish-article/app/article/zhaowulist ", {
                page: page.toString(),
                limit: "10"
            }).then(({ data }) => {
                let pageInfo = data.page.list;
                pageInfo.forEach((item) => {
                    if (item.img.match(/https/)) {
                        item.img = item.img.replace(/https/, 'https')
                    }
                    this.newsList.push(item);
                });
                if (data.page.totalPage > page) {
                    this.busy = false
                } else {
                    this.newsList = this.newsList.concat(this.oldNewList)
                    this.busy = true
                }
            }).catch(function (error) {
                console.log(error);
            })
        },
        loadMore() {
            this.page++
            console.log(this.page)
            this._getNewsList(this.page)
        },

        newsJump(item) {
            if (item.id) {
                this.$router.push({ name: 'news_details', query: { id: item.id, date: item.publishDate } })
            } else {
                console.info(item.routerName)
                this.$router.push({ name: item.routerName })
            }
        },
        Scrollbottom() {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            let clientHeight = document.documentElement.clientHeight;
            let scrollHeight = document.documentElement.scrollHeight;
            if (scrollTop + clientHeight >= scrollHeight) {
                console.log("滚动到底部了")
                this.loadMore()
            }
        },
    },
    created() {
        this._getNewsList(this.page)
        window.addEventListener('scroll', this.Scrollbottom);
    },
    destroyed() {
        window.removeEventListener('scroll', this.Scrollbottom)//页面离开后销毁监听事件
    },
}
</script>

<style scoped lang="scss">
.box {
  //height: 600px;
  /*min-height: 800px;*/
  overflow: auto;

  .banner {
    background-image: url("../../assets/news/beijing.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 350px;
    color: #fff;
    //display: flex;
    align-items: center;
    //text-align: right;

    .iaas_left {
      margin-left: 15.5%;
      padding-top: 96px;

      .title {
        display: flex;
        font-size: 37px;
        margin-top: 36px;
        color: #282B31;
      }

      .text {
        font-size: 26px;
        color: #282B31;
        margin-top: 7px;
      }
    }

      .btnBox {
        margin-right: 330px;
        margin-top: 56.9px;

        .btn {
          width: 139px;
          height: 39px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 14px;
          background: #0069FD;
          border-radius: 20px;
          margin-left: 295px;
          padding-top: 13px;
        }
      }

  }
  .box-big{
    background-color: #fff;


    .newsBox {
      /*margin-top: 100px;*/

      .content {
        position: relative;
        /*background-color: #FAFBFC;*/
        padding: 5px 180px;

        /*box-shadow: 1px 2px 7px #d3d3d3;*/

        .newsList {
          width: 100%;

          .newsItem {
            display: flex;
            justify-content: space-around;
            /*align-items: center;*/
            /*align-items: flex-start;*/
            margin: 20px 0;
            padding: 30px 0;
            background: #FAFBFC;
            /*border-bottom: 1px solid #ddd;*/
            cursor: pointer;

            .item_top {
              display: flex;

            }

            .item_timer_sz {
              width: 160px;
              height: 42px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 100;
              margin: -10px 12px;
              color: #909091;
              line-height: 42px;
            }

            .item_center {
              width: 39px;
              height: 1px;
              border: 1px solid rgba(209, 209, 209, 1);
              background: #D1D1D1;
              margin: 10px 12px;
            }

            .itemImg {
              width: 15%;

              img {
                width: 90%;
                //height: 90%;
              }
            }

            .itemBox {
              margin-right: 40px;
              .item_bottom {
                .item_text {
                  width: 685px;
                  padding: 15px 0;
                  font-size: 14px;
                  letter-spacing: 2px;
                  line-height: 25px;
                  color: #353F52;
                  display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                }

                .item_title {
                  width: 706px;
                  min-width: 706px;
                  line-height: 30px;
                  font-size: 16px;
                  font-weight: 600;
                  color: #282F3C;
                }
              }
            }
          }
        }
      }
    }
  }

}

</style>
